/** Access screen rules (screenshots/52). Mirrors Better Auth org roles; enforced again on the server. */
import type { OrgRole } from "../nav/navConfig";

export interface Member { id: string; name: string; email: string; role: OrgRole; lastActive: string | null; pending?: boolean }

/**
 * Who may change whose role:
 *  - only owner/admin can change roles at all
 *  - admins can't touch owners or make someone an owner
 *  - the last owner can't be demoted (transfer ownership first)
 */
export function canChangeRole(actor: OrgRole, target: Member, to: OrgRole, members: Member[]): { ok: true } | { ok: false; reason: string } {
  if (actor === "member") return { ok: false, reason: "Only owners and admins manage access" };
  if (actor === "admin" && (target.role === "owner" || to === "owner")) return { ok: false, reason: "Only an owner can change owners" };
  const owners = members.filter((m) => m.role === "owner" && !m.pending);
  if (target.role === "owner" && to !== "owner" && owners.length <= 1) return { ok: false, reason: "Transfer ownership before removing the last owner" };
  return { ok: true };
}

export const roleCounts = (members: Member[]) => ({
  owner: members.filter((m) => m.role === "owner").length,
  admin: members.filter((m) => m.role === "admin").length,
  member: members.filter((m) => m.role === "member").length,
});

/** Domain sign-in: anyone with the org's email domain can request to join (admin approves). */
export const matchesDomain = (email: string, domain: string) => email.trim().toLowerCase().endsWith(`@${domain.toLowerCase()}`);
